import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function ChatIcon(props) {
    const { ...rest } = props;
    return (
        <SvgIcon {...props} viewBox="0 0 16 14" {...rest}>
            <title>Icon_Chat</title>
            <path fill="#fff" d="M13.8,6.6h0c0-3-3.2-5.5-7-5.5s-7,2.5-7,5.5a5.4,5.4,0,0,0,4,5c-.9,1.8-2,3.5-2,3.5s4.3-.6,6.6-2.8a4.9,4.9,0,0,0,2.1.8,7.7,7.7,0,0,0,3.3,2V12.4a3.2,3.2,0,0,0,2-2.9A3.5,3.5,0,0,0,13.8,6.6Zm-9.6,4C2.1,9.8.8,8.2.8,6.5S3.5,2,6.8,2s5.7,1.9,5.9,4.2L11.3,6C8.8,6,6.8,7.6,6.8,9.5a3.2,3.2,0,0,0,.8,2.1,10.9,10.9,0,0,1-3.7,1.9A10.9,10.9,0,0,0,4.7,12l.6-1Zm9.1,1-.5.2v1.7a9.6,9.6,0,0,1-1.7-1.3l-.2-.2h-.3a4.2,4.2,0,0,1-1.2-.4h0l-.6-.3h0l-.5-.4a2.4,2.4,0,0,1-.5-1.4C7.8,8.2,9.4,7,11.3,7a3.5,3.5,0,0,1,1.4.3h0l.9.4a2.4,2.4,0,0,1,1.2,1.8A2.6,2.6,0,0,1,13.3,11.6Z" transform="translate(0.2 -1)" />
        </SvgIcon >
    );
}